import { render, staticRenderFns } from "./PlusMinusNumberField.vue?vue&type=template&id=228441b2&scoped=true"
import script from "./PlusMinusNumberField.vue?vue&type=script&lang=js"
export * from "./PlusMinusNumberField.vue?vue&type=script&lang=js"
import style0 from "./PlusMinusNumberField.vue?vue&type=style&index=0&id=228441b2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228441b2",
  null
  
)

export default component.exports